import { logger, sanitizeError } from "../utils/logger.js";
import { updateAppointment } from "../logic/appointment/index.js";

export const VIEW_APPOINTMENTS_PATH = "/viewAppointments";

const runAppointmentUpdate = async ({
  request,
  navigate,
  payload,
  setIsProcessing,
  onSuccess,
  missingMessage,
  failureMessage,
}) => {
  if (!request) {
    logger.error(missingMessage);
    return;
  }

  try {
    setIsProcessing(true);
    const updatedAppointment = await updateAppointment(
      navigate,
      request._id,
      request.idEncuentroNegocios,
      payload,
    );
    if (updatedAppointment) {
      onSuccess(updatedAppointment);
    }
  } catch (err) {
    logger.error(failureMessage, { err: sanitizeError(err) });
  } finally {
    setIsProcessing(false);
  }
};

export const rejectAppointmentRequest = ({
  request,
  navigate,
  eventData,
  setIsProcessing,
}) => {
  logger.info("Reject request clicked");
  return runAppointmentUpdate({
    request,
    navigate,
    setIsProcessing,
    missingMessage: "No request data available for rejection",
    failureMessage: "Error rejecting appointment:",
    payload: { appointmentInformation: { estado: "rejected" } },
    onSuccess: (updatedAppointment) => {
      logger.info("Appointment rejected successfully:", {
        data: updatedAppointment,
      });
      logger.info("Navigating back after rejection with eventData:", {
        data: eventData,
      });
      navigate(VIEW_APPOINTMENTS_PATH, { state: { event: eventData } });
    },
  });
};

export const approveAppointmentRequest = ({
  request,
  navigate,
  setIsProcessing,
  setIsScheduleModalOpen,
}) => {
  logger.info("Approve request clicked");
  return runAppointmentUpdate({
    request,
    navigate,
    setIsProcessing,
    missingMessage: "No request data available for approval",
    failureMessage: "Error approving appointment:",
    payload: { appointmentInformation: { estado: "approved" } },
    onSuccess: (updatedAppointment) => {
      logger.info("Appointment approved successfully:", {
        data: updatedAppointment,
      });
      setIsScheduleModalOpen(true);
    },
  });
};

export const likeAppointmentRequest = ({
  request,
  navigate,
  setIsProcessing,
  setIsLiked,
  setRequest,
}) => {
  logger.info("Like request clicked");
  if (!request) {
    logger.error("No request data available for liking");
    return Promise.resolve();
  }
  const newMeGustaValue = !request.meGusta;
  logger.info(`Updating appointment meGusta to ${newMeGustaValue}`);
  return runAppointmentUpdate({
    request,
    navigate,
    setIsProcessing,
    missingMessage: "No request data available for liking",
    failureMessage: "Error updating appointment meGusta:",
    payload: { appointmentInformation: { meGusta: newMeGustaValue } },
    onSuccess: (updatedAppointment) => {
      logger.info("Appointment meGusta updated successfully:", {
        data: updatedAppointment,
      });
      setIsLiked(newMeGustaValue);
      setRequest((prev) => ({ ...prev, meGusta: newMeGustaValue }));
    },
  });
};

export const confirmAppointmentSchedule = ({
  request,
  navigate,
  eventData,
  appointmentInfo,
  setIsProcessing,
  setIsScheduleModalOpen,
}) => {
  logger.info("Scheduling appointment with info:", { data: appointmentInfo });
  return runAppointmentUpdate({
    request,
    navigate,
    setIsProcessing,
    missingMessage: "No request data available for scheduling",
    failureMessage: "Error scheduling appointment:",
    payload: {
      appointmentInformation: {
        fecha: appointmentInfo.fecha,
        horaInicio: appointmentInfo.horaInicio,
        horaFin: appointmentInfo.horaFin,
        fechaHoraInicioPlanificada:
          appointmentInfo.fechaHoraInicioPlanificada,
      },
    },
    onSuccess: (updatedAppointment) => {
      logger.info("Appointment scheduled successfully:", {
        data: updatedAppointment,
      });
      setIsScheduleModalOpen(false);
      logger.info("Navigating back after scheduling with eventData:", {
        data: eventData,
      });
      navigate(VIEW_APPOINTMENTS_PATH, {
        state: { event: eventData, showScheduleSuccess: true },
      });
    },
  });
};
